import { useEffect } from "react";
import { ReactLenis } from "lenis/react";

export default function SmoothScroll({ children }) {
    return (
        <ReactLenis
            root
            options={{
                lerp: 0.09,
                duration: 1.35,
                smoothWheel: true,
                syncTouch: false,
            }}
        >
            {children}
        </ReactLenis>
    );
}
